module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER TWO")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("UCIANO")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERNALDI")])]), _vm._v(" placed Lee’s suitcase inside the train, then gave her a fierce hug. “Thank you for helping us,” he whispered in heavily accented English. “I’m counting on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee shivered at the remark which had come straight from his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After he stepped back on the platform to pull Sophie into his arms again, the two of them waved to Lee until the train moved out of the station. Once they’d disappeared, she picked up her suitcase and found a seat inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sophie’s Swiss boyfriend lived in Ascona, a town in the Italian canton of Ticino. Though he came from a family of wealthy hoteliers, he held no title and could never be on a par with Raoul. The prestigious House of D’Arillac had prevailed over the Frenchspeaking cantons for centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The year before, the two of them had met by chance while Sophie and Lee were vacationing at one of the Bernaldi hotels on Lake Maggiore. When the lift had stuck because of a brief power outage Sophie, who feared heights, had become very frightened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was Luciano himself, with his black hair and aquiline features, who had rescued them. Lee might as well have been nonexistent because he and Sophie had fallen for each other on the spot. Over the last twelve months their feelings had deepened until they could hardly bear to be apart.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("The man had been begging Sophie to marry him, but she was torn because she loved her parents and couldn’t stand to go against their wishes. Many times Lee had tried to put ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("herself in Sophie’s place, but couldn’t. All she knew was that if she were the one madly in love, she’d probably forget her title and run off with Luciano.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But maybe she could say that so easily because she’d lost all sense of family when her parents and fiancé had been killed. That had been three years ago, a long enough time to stop actively grieving.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the funeral, Lee’s aunt and uncle from West Yellowstone, Montana, had offered her a home with them. But Sophie had begged Lee to return to Switzerland where she could continue to live and work near her. She’d argued that Madame Simoness needed her, not to mention the girls at the school who would help her forget her pain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the end, Lee had chosen to go back to Nyon. Between everyone there, especially Sophie’s parents, she had been able to make it through that agonizing period. Now, sadly, Sophie was asking something of Lee that seemed such a betrayal of the Ramblets’s love and caring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time the train reached the station in Zermatt, she could hardly breathe for the tension that constricted her chest. When the train emptied, she found herself in the middle of a crowd that swept her along the platform to the entrance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t have arrived on a more beautiful, brisk afternoon. The last time she’d stayed here overnight, with the boarders from the school, clouds had obscured the Matterhorn. Today it rose in the distance like a giant snow-covered sentinel, overlooking the lush green valley dotted with chalets and hotels.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sight was so beautiful Lee could hardly believe it was real. But her appreciation was short-lived the moment she saw the “Miami” sign held by a lanky male in dark trousers and a windbreaker.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("That would be Philippe, Raoul’s friend. He stood in front of one of those electric cars, the only kind allowed in ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Zermatt. She thought he looked very French and attractive in his own way, with overly long dark hair and hooded eyes. While his gaze swept the crowd for signs of Sophie, it managed to linger on Lee in male appreciation several times in the process.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With her cap of silvery-gold curls and violet eyes, she’d become used to the stares of men, especially the dark-haired types living in Europe and the Middle East. But to capture the interest of Prince Raoul was something else again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hoping her legs would support her, she walked toward the man. “Hello, Philippe,” she said in English. Might as well play the part of the American tourist to make everything real.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His black eyes gleamed with flattering interest. “Hello,” he responded in kind with a French accent. “Have we met before?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, we haven’t. But my best friend told me you would answer to that name and be carrying a sign I would recognize. If we could get in the car, I will tell you everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her explanation wiped the lazy amusement from Philippe’s expression. After eyeing her speculatively, he opened the car door for her. Once he’d helped her inside, he stashed the sign and her bag, then went around to the driver’s side and slipped behind the wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He studied her as if she were a puzzle that needed solving. “Who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My name is Lee Gresham. I’m a close friend of Princess Sophie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The lie was about to begin.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“She asked me to accompany her to Zermatt, but she became ill on the train and was forced to return to Geneva. I wanted to go back with her, but she hated disappointing ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Prince Raoul and begged me to see him in person so I could tell him what happened.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His body remained motionless, yet she could tell something of significance was going on inside him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you mind taking me to his chalet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, no. Of course not,” he hastened to assure her, but his thoughts had been far away. After a moment he started the car and they were off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sat nervously in the seat, frightened to see that, so far, Sophie’s plan was going exactly as she’d outlined.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He drove to the outskirts of the world-famous Swiss village. From there the road wound up into a flowering hillside where she spied a small, charming brown and white chalet with an outside staircase that led to the top story. There were two other cars in the parking area.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before Philippe could come around to assist her, a man had emerged from the back entrance of the house. Lee would have known the Prince anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the time she’d first arrived at boarding school in Nyon she’d seen his picture in the newspapers and magazines. It was no secret that she, along with the other boarders, had pretty well worshipped him the way many teens idolized a famous film or rock star.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After she’d become friends with Sophie, and found out she was betrothed to him, Lee had gone through a period of coveting Sophie’s future intended. But that destructive emotion had ended when Lee met Todd and fell in love.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They would be married right now except for the tragedy that had shattered her life and made her view the world through different eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Having lost everyone close to her, Lee took Sophie’s love affair with Luciano seriously. The two were so besotted it seemed criminal that an accident of birth was forcing Sophie to marry a man for whom she had no feelings. Lee had determined to help them in any way she could.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But talking about Prince Raoul in the abstract was one thing. Meeting him in person for the first time was an entirely different matter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beneath the natural gold highlights of his dark blond hair blazed a pair of eyes so hot a blue they rivaled flame. Lines of character and intelligence were carved in a rugged face tanned to mahogany by the elements. He stood at least six feet two inches of lean muscle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he approached the car, her heart raced at the impact of his virile masculinity. For sheer physical appeal, he made every male she’d ever met before look inadequate by comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sophie had to be a different species of female not to have fallen for Raoul on sight!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Closer now, she saw him blink when he realized a total stranger was sitting next to Philippe. He opened the door and lowered his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their eyes met in a long searching glance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the heart-stopping silence a thorough scrutiny seemed to be taking place on both sides. Lee was so mesmerized she couldn’t look away. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This")]), _vm._v(" was the man she was supposed to—")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Raoul?” Philippe interjected, causing her to remember why she was here. “This is Lee Gresham, a close friend of Sophie’s,” he explained in English. “Ms Gresham? This is Raoul Mertier.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“H-how do you do, Your Highness.” She stumbled over the words, feeling as foolish as any starstruck schoolgirl meeting her ultimate fantasy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Call me Raoul.” He spoke English with barely a trace of accent in a deep voice she found as attractive as the rest of him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh—” Her heart was pounding with a fury that made her feel breathless. “Sophie would be here if she hadn’t become n-nauseous on the train and—”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why don’t you come inside the chalet where we can talk?” he interrupted smoothly and helped her from the car. By accident their bodies brushed against each other as he leaned inside to retrieve her bag. She felt as if she’d just come up against a live wire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Without waiting for him, she hurried toward the house, knowing she couldn’t possibly follow through with a plan that had been flawed from the beginning. One look into those brilliant blue depths of his and she’d realized he wasn’t a man to be trifled with.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This wasn’t going to work.")]), _vm._v(" She knew it wasn’t!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As soon as she’d explained about Sophie she would ask to be driven to the hotel where she would phone her friend and tell her she couldn’t go through with the plan.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Raoul managed to beat her to the entrance. “This way,” he murmured, holding the door open for her. On a shaky whisper she said thank you and moved past him, aware her five feet five inches wouldn’t seem very tall to him. Then she chastised herself for thinking any personal thoughts at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Would you care to freshen up in here first?” He’d stopped outside a door halfway down the corridor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, I’m fine. Thank you anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt his gaze travel over her in swift appraisal before he led her to the front room which gave out on a superb view of the storybook surroundings. He placed her bag against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To her surprise the interior of the chalet was rustic rather than luxurious. The perfect paradise for a skier, with its huge grate hearth and large, comfortable couches made for lounging. There was a set of double doors leading to the dining room. At the end of the living room she noticed a staircase which led to what looked like a loft.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Philippe seemed to have disappeared.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Her palms grew damp. Ill at ease, she rubbed them ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("against her hips covered by her black cotton sweater and matching wool pants. It was an outfit Sophie had insisted made the most of Lee’s voluptuous curves and coloring.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dear God—")]), _vm._v(" What was she doing here alone in this chalet with Sophie’s fiancé? This was madness! Prince or not, he was a man first. One who deserved all the honesty she had in her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stood in the center of the room with his legs slightly apart. She noted he had a bearing as splendid as his title. “May I offer you a drink or something to eat?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head. “That’s very kind of you, but no.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then sit down and tell me what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Averting her eyes, so she wouldn’t get caught staring at him again, Lee did his bidding. “Sophie asked me to come on this trip with her. Quite soon after we left Geneva she started to feel ill. She couldn’t decide if she’d eaten something that didn’t agree with her, or if she was coming down with the flu. Finally she alerted her parents that she was returning home and got off the train. When I talked to her a little while ago someone had already picked her up, so I know she’s in good hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hoping that lightning wouldn’t strike her, she continued, “Sophie refused to let me go back with her. She said it was vital I deliver her regrets to you in person because she hated disappointing you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He rubbed his chest in an unconscious gesture. “More than anything, I’m sorry she was distressed enough to have to return home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He sounded so sincere Lee found herself loathing this untenable situation. “The thing is, she knew you would have gone to a lot of trouble to make elaborate plans for her. Naturally she didn’t feel that a phone call would suffice. If you’d like to contact her now, I’ll give you her cellphone number, but I would imagine she’s resting at the moment.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No doubt Sophie was consoling herself in Luciano’s arms while they waited for Lee to carry out a scheme destined for failure. No matter how much she wanted to help them, she couldn’t take this charade any further.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee wrote the phone number down on a piece of note-paper from her handbag and placed it on the coffee table. Unable to sit still, she got to her feet and finally dared to look at him once more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I—I don’t know what else to say except that I can assure you she’s very sorry. Depending on her condition, I’m sure you’ll hear from her in the morning, if not tonight. Now, if I could prevail on your friend Philippe to drive me to the Belle-Vue, I’d be grateful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His hand stilled against his solid chest. “You’re meeting someone there?” he questioned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, no. It’s a place to stay for the night before I return to Nyon tomorrow.” No more lies.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His veiled eyes studied her upturned features. “What’s in Nyon?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The boarding school where I live and work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wouldn’t be Beau Lac, would it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded. “Sophie and I both attended it for several years. While we were there we became best friends. I stayed on and obtained my university degree in Geneva. Now I’m one of the staff.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He moved closer, filling her with a fluttery sensation. “Where are you from in America?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oddly enough she got the impression he wasn’t making polite conversation. He sounded as if he really wanted to know. She couldn’t understand why he was asking so many questions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jackson, Wyoming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes flared a darker blue. “I’ve been there. That’s some of the most beautiful country I’ve ever seen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He had the most beautiful eyes she’d ever seen.")])])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought it was paradise until I saw pictures of the Swiss Alps for the first time. When I was old enough to climb the Grand Teton with my father, I pretended I was on the Matterhorn.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The slow smile that broke the corners of his mouth reached his eyes, illuminating dark places in her soul where she’d thought the light had been extinguished forever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you find goats and hear yodeling?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She chuckled in spite of her nervousness. “I’m afraid not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Have you ever been up on the Matterhorn?” came the silken inquiry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” she whispered, fighting tears because her father had promised it would be their next climb. But that had been right before everything ended…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A strange tension hovered between them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How would you like to spend your weekend climbing it with me?”")])])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a5e3f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426881688_ch03.vue
// module id = 78
// module chunks = 0